import { createContext, useContext } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { MobileSheet, MobileSheetBody, MobileSheetCloseButton, MobileSheetContent, MobileSheetHeader, MobileSheetTitle, MobileSheetTrigger } from "./mobile-sheet";
import useIsMobile from "../../hooks/useIsMobile";

const MobileContext = createContext(false);

export function ResponsivePopover(props) {
  const mobile = useIsMobile();
  const Root = mobile ? MobileSheet : Popover;
  return <MobileContext.Provider value={mobile}><Root {...props} /></MobileContext.Provider>;
}

export function ResponsivePopoverTrigger(props) {
  const mobile = useContext(MobileContext);
  const Trigger = mobile ? MobileSheetTrigger : PopoverTrigger;
  return <Trigger {...props} />;
}

export function ResponsivePopoverContent({ title = "Filtres", align, className = "", children, ...props }) {
  const mobile = useContext(MobileContext);
  if (mobile) return (
    <MobileSheetContent aria-describedby={undefined} {...props}>
      <MobileSheetHeader>
        <MobileSheetTitle>{title}</MobileSheetTitle>
        <MobileSheetCloseButton />
      </MobileSheetHeader>
      <MobileSheetBody className={`${className} !w-auto !max-w-none`}>{children}</MobileSheetBody>
    </MobileSheetContent>
  );
  return <PopoverContent align={align} className={className} {...props}>{children}</PopoverContent>;
}
